// src/utils/pdf/openProtectedPdf.js

export async function openProtectedPdf({
  url,
  token
}) {

  const reportWindow = window.open("", "_blank");

  try {

    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    if (!res.ok) {

      const text = await res.text();
      console.error("❌ PDF fetch error:", text);

      if (reportWindow) {
        reportWindow.document.write("<p>Could not load document.</p>");
        reportWindow.document.close();
      }

      return;
    }

    const blob = await res.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    if (reportWindow) {
      reportWindow.location.href = blobUrl;
    } else {
      window.open(blobUrl, "_blank");
    }

  } catch (err) {

    console.error("❌ Could not open PDF:", err);

    if (reportWindow) {
      reportWindow.document.write("<p>Could not load document.</p>");
      reportWindow.document.close();
    }

  }

}